<div class="outlet-container d-flex fd-col ai-center">

  <div class="outlet-padding">
    <!--  -->
    <div class="screen-container d-flex fd-col ai-stretch">

      <div class="d-flex flex-wrap ai-stretch">

        <h4 class="margin">Invitations</h4>

      </div>

      <div class="d-flex flex-wrap ai-stretch">

        <div class="margin card flex-1 d-flex fd-col ai-stretch">
          <suvo-bi-organisation-invite-list></suvo-bi-organisation-invite-list>
        </div>

      </div>

    </div>
    <!--  -->
  </div>
</div>